import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import type { IParamsSendFromSmartOption } from 'entities/SendFrom'
import { SendFromStore } from 'widgets/SendFrom'
import { type ISendFromStoreProps } from 'widgets/SendFrom/store/SendFromStore'

export type IFlowSendFromBlockParams = {
  inboxId: number | null
  sendingOptions?: {
    smart_option?: IParamsSendFromSmartOption
    number_id?: number | null
    send_from?: string
    teamId?: number | null
  }
}

export class SendFromBlockStore {
  sendFromStore: SendFromStore
  constructor(
    private _entities: IEntitiesStore,
    params?: IFlowSendFromBlockParams | null,
    sendFromStoreProps?: ISendFromStoreProps
  ) {
    this.sendFromStore = new SendFromStore(this._entities, sendFromStoreProps)

    if (params) {
      this.sendFromStore.setSelectItem(
        {
          inbox_id: params.inboxId,
          number_id: params.sendingOptions?.number_id,
          smart_option: params.sendingOptions?.smart_option,
        },
        true
      )
    }
    makeAutoObservable(this)
  }

  get params(): IFlowSendFromBlockParams {
    return {
      inboxId: this.sendFromStore.inbox_id || null,
      sendingOptions:
        this.sendFromStore.smart_option || this.sendFromStore.number_id
          ? {
              smart_option: this.sendFromStore.smart_option,
              number_id: this.sendFromStore.number_id,
            }
          : undefined,
    }
  }

  error = ''
  setError = (value: string) => {
    this.error = value
  }

  validate = () => {
    let isValid = true
    if (!this.params?.inboxId) {
      this.setError('Required field')
      isValid = false
    } else {
      this.setError('')
    }

    return isValid
  }
  reset = () => {
    this.sendFromStore.reset()
  }
}
